const SET_REQUEST = "@request/setRequest";

export { SET_REQUEST };
